import { useMutation } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { i18n } from '@zet/localization'

import { verifyPhoneNumber } from '../functions'

function useResendVerificationRequest() {
  const toast = useToast()
  return useMutation(verifyPhoneNumber, {
    onSuccess(response, variables) {
      const { reason, lockedTill } = response
      if (lockedTill) {
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description: reason,
          hideAfter: 3000,
        })
      } else {
        toast?.show({
          intent: 'success',
          heading: i18n.t('toastMessages.success'),
          description: variables?.otpLess
            ? 'Resent verification link'
            : 'Resent OTP',
          hideAfter: 3000,
        })
      }
    },
    onError(error) {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description:
          error?.response?.data?.error?.message ??
          i18n.t('toastMessages.somethingWentWrong'),
        hideAfter: 3000,
      })
      return error
    },
  })
}
export { useResendVerificationRequest }
